import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  MailOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Checkbox, Col, Row } from "antd";
import PropTypes from "prop-types";
import { translate } from "../../locale";

const Label = ({ checkbox, type }) => {
  let bgDarkColor = "";
  let bgLightColor = "";
  let icon = null;
  if (type === "exclamation") {
    bgDarkColor = "bg-custom_darkred";
    bgLightColor = "bg-custom_red";
    icon = (
      <ExclamationCircleOutlined className="text-2xl lg:text-4xl text-white ml-2 lg:ml-4 leading-3" />
    );
  } else if (type === "warning") {
    bgDarkColor = "bg-custom_darkyellow";
    bgLightColor = "bg-custom_yellow";
    icon = (
      <WarningOutlined className="text-2xl lg:text-4xl text-white ml-2 lg:ml-4 leading-3" />
    );
  } else if (type === "check") {
    bgDarkColor = "bg-custom_green";
    bgLightColor = "bg-custom_green";
    icon = (
      <CheckCircleOutlined className="text-2xl lg:text-4xl text-white ml-2 lg:ml-4 leading-3" />
    );
  }

  return (
    <Row justify="start" className="mb-2" style={{ height: 68 }}>
      <Col
        className={`flex items-center rounded-tl rounded-bl py-4 px-2 lg:px-8 w-16 lg:w-32 ${bgDarkColor}`}
      >
        {checkbox ? (
          <>
            <MailOutlined className="text-2xl lg:text-4xl text-white mr-2 leading-3" />
            <Checkbox
              name={checkbox.name}
              onChange={checkbox.onChange}
              checked={checkbox.checked}
              value={checkbox.value}
            />
          </>
        ) : (
          <span className="text-white">{translate("Normal")}</span>
        )}
      </Col>
      <Col
        className={`flex items-center rounded-tr rounded-br py-4 px-2 lg:px-8 w-14 lg:w-32 ${bgLightColor}`}
      >
        {icon}
      </Col>
    </Row>
  );
};

Label.propTypes = {
  checkbox: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    value: PropTypes.bool,
  }),
  type: PropTypes.oneOf(["exclamation", "warning", "check"]).isRequired,
};

Label.defaultProps = {
  checkbox: null,
};

export default Label;
